import React from 'react';
import CloseRounded from '@mui/icons-material/CloseRounded';
import GlobalStyles from '@mui/material/GlobalStyles';
import { Box, IconButton, Modal as MuiModal, Typography } from '@mui/material';

/** Google Places appends `.pac-container` to `body`. Modal scroll-lock + focus trap break it — fix z-index and opt out when using Places. */
const placesAutocompleteGlobalStyles = (
  <GlobalStyles
    styles={{
      '.pac-container': {
        zIndex: '2147483647 !important',
      },
    }}
  />
);

export default function Modal({ open, onClose, fullScreen, children, title }) {
  return (
    <>
      {open ? placesAutocompleteGlobalStyles : null}
      <MuiModal open={open} onClose={onClose}>
        <Box
          sx={{
            position: 'absolute',
            top: fullScreen ? 0 : '50%',
            left: fullScreen ? 0 : '50%',
            right: fullScreen ? 0 : 'auto',
            bottom: fullScreen ? 0 : 'auto',
            transform: fullScreen ? 'none' : 'translate(-50%, -50%)',
            width: fullScreen ? '100%' : 'calc(100% - 80px)',
            maxWidth: fullScreen ? '100%' : 440,
            height: fullScreen ? '100%' : 'auto',
            maxHeight: fullScreen ? '100%' : 'min(90vh, calc(100% - 80px))',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 2,
            pt: 1.5,
            outline: 0,
            overflow: 'auto',
            borderRadius: fullScreen ? 0 : 2,
            my: fullScreen ? 0 : 2,
            mx: fullScreen ? 0 : 'auto',
            boxSizing: 'border-box',
          }}
        >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 1,
            mb: 1.5,
          }}
        >
          {title ? (
            <Typography variant="h6" component="h2" sx={{ pr: 1, lineHeight: 1.3, flex: 1 }}>
              {title}
            </Typography>
          ) : (
            <Box sx={{ flex: 1 }} />
          )}
          {onClose ? (
            <IconButton
              aria-label="Close"
              onClick={onClose}
              size="small"
              sx={{ mt: -0.5, mr: -0.5, color: 'text.secondary' }}
            >
              <CloseRounded />
            </IconButton>
          ) : null}
        </Box>
        {children}
      </Box>
    </MuiModal>
    </>
  );
}
